import { createFileRoute } from '@tanstack/react-router';
import AcceptInvitation from '@/pages/accept-invitation';
import z from '@/lib/zod';

export const Route = createFileRoute('/accept-invitation')({
  component: AcceptInvitation,
  validateSearch: z.object({ token: z.string() }),
});
